<template>
  <div
    class="w-full inline-block text-center py-4 cursor-pointer font-medium rounded text-white focus:outline-none"
    :class="[bg]"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    bg: {
      default: 'bg-nw-red hover:bg-red-600',
      type: String
    }
  }
}
</script>
